import { render } from "./SocialSearchChart.vue?vue&type=template&id=71cda3e0&ts=true"
import script from "./SocialSearchChart.vue?vue&type=script&lang=ts"
export * from "./SocialSearchChart.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__